//  import { useState } from "react"
// import { Box,Button,ButtonGroup } from "@chakra-ui/react"
// import KnjigaSelect from "../knjiga/KnjigaSelect"
// import GovedaList from "../govedo/GovedaList"
// import {MdCancel,MdSaveAlt} from 'react-icons/md';
// //import { getKnjige } from '../../util/apiKnjiga';

// import GovedaSelected from "../govedo/GovedaSelected";

// export default function GovedoToBoks({size='xs',bokslokacija_id=-1,onClose,onSave}) {
//     const [state,setState]=useState({selectedknjigaid:-1,selectedgoveda:[]});
//     const knjigaChanged=(knjigaid)=>{
//         setState({...state,selectedknjigaid:knjigaid})
        
//     }

//     const onGovedoSelect=(_gov)=>{
//         let _postoji=false;
//         for (let index = 0; index < state.selectedgoveda.length; index++) {
//             if (state.selectedgoveda[index].govedo_id===_gov.govedo_id) {
//                 _postoji=true;
//             }
//         }
//         if (!_postoji) {
//             const _ar=[...state.selectedgoveda]
//             _ar.push(_gov);
//             setState({...state,selectedgoveda:_ar});
//         }
//     }

//     const onGovedoRemove=(_gov)=>{
//         let _govid=0;
//         if (isNaN(_gov) && Object.keys(_gov).indexOf("govedo_id")>-1) {
//             _govid=_gov.govedo_id;
//         } else {
//             _govid=_gov;
//         }
//         const _idx=state.selectedgoveda.findIndex((item)=>{
//             return item.govedo_id===_govid;
//         })

//         if (_idx>-1) {
//             const _ar=[...state.selectedgoveda]
//             _ar.splice(_idx,1);
//             setState({...state,selectedgoveda:_ar});
//         }
//     }

//     const getGovedoIdOfSelected=()=>{
//         const _ar=[];
//         for (let index = 0; index < state.selectedgoveda.length; index++) {
//             _ar.push(state.selectedgoveda[index].govedo_id);            
//         }
//         return _ar;
//     }

    
//   return (
//         <Box display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'} gap={'1rem'} h={'100%'} w={'100%'}>
//             <Box display={'flex'} flexDir={'row'} gap={'1rem'}>
//                 <Box display={'flex'} flex={1}>
//                     <KnjigaSelect onKnjigaChange={knjigaChanged} minimalView={true}/>
//                 </Box>
//                 <Box display={'flex'} flex={1}>
                    
//                 </Box>
//             </Box>
//             <Box display={'flex'} flexDir={'row'} flex={1} gap={'1rem'}>
//                 <Box display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'}>
//                     <Box bg={'grunt.700'} color={'white'} w={'100%'}>Odabir goveda</Box>
                    
//                     <Box w={'100%'} overflowY={'auto'}  display={'flex'} flexDir={'column'} flex={1}>
//                         <GovedaList _disableboksidgoveda={bokslokacija_id} knjiga_id={state.selectedknjigaid} rowsperpage={15} showButtonSpremi={false} showButtonOdustani={false}
//                             naslov={"Odabir goveda"} onSelectGovedo={onGovedoSelect} onRemoveGovedo={onGovedoRemove} preselectedgoveda={getGovedoIdOfSelected()} /*onClose={()=>setShowselectgoveda(false)} preselectedgoveda={getGovedoIdOfSelected()} omigracijaid={odlazakMigracijaId}*//>
//                     </Box>
//                 </Box>
//                 <Box display={'flex'} flexDir={'column'} flex={1} overflowY={'auto'}>
//                     <Box bg={'grunt.700'} color={'white'} w={'100%'}>Odabrana goveda</Box>
//                     <Box w={'100%'} overflowY={'auto'} display={'flex'} flexDir={'column'} flex={1}>
//                         <GovedaSelected data={state.selectedgoveda} onDelete={onGovedoRemove}/>
//                     </Box>
//                 </Box>
                
//             </Box>
//             <ButtonGroup gap={'1rem'} mr={'10rem'}>
//                     <Button rightIcon={<MdSaveAlt/>} colorScheme={'grunt2'} size={size} onClick={()=>onSave(state.selectedgoveda)} >Spremi</Button>
//                     <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
//             </ButtonGroup>
//         </Box>
//   )
// }
 

import { useState } from "react"
import { Box,Button,ButtonGroup } from "@chakra-ui/react"
import KnjigaSelect from "../knjiga/KnjigaSelect"
import GovedaList from "../govedo/GovedaList"
import {MdCancel,MdSaveAlt} from 'react-icons/md';
//import { getKnjige } from '../../util/apiKnjiga';

import GovedaSelected from "../govedo/GovedaSelected";

export default function GovedoToBoks({size='xs',bokslokacija_id=-1,onClose,onSave}) {
    const [state,setState]=useState({selectedknjigaid:-1,selectedgoveda:[]});
    const knjigaChanged=(knjigaid)=>{
        setState({...state,selectedknjigaid:knjigaid})
        
    }

    const onGovedoSelect=(_gov)=>{
        let _postoji=false;
        for (let index = 0; index < state.selectedgoveda.length; index++) {
            if (state.selectedgoveda[index].govedo_id===_gov.govedo_id) {
                _postoji=true;
            }
        }
        if (!_postoji) {
            const _ar=[...state.selectedgoveda]
            _ar.push(_gov);
            setState({...state,selectedgoveda:_ar});
        }
    }

    const onGovedoRemove=(_gov)=>{
        let _govid=0;
        if (isNaN(_gov) && Object.keys(_gov).indexOf("govedo_id")>-1) {
            _govid=_gov.govedo_id;
        } else {
            _govid=_gov;
        }
        const _idx=state.selectedgoveda.findIndex((item)=>{
            return item.govedo_id===_govid;
        })

        if (_idx>-1) {
            const _ar=[...state.selectedgoveda]
            _ar.splice(_idx,1);
            setState({...state,selectedgoveda:_ar});
        }
    }

    const getGovedoIdOfSelected=()=>{
        const _ar=[];
        for (let index = 0; index < state.selectedgoveda.length; index++) {
            _ar.push(state.selectedgoveda[index].govedo_id);            
        }
        return _ar;
    }

    
  return (
        <Box display={'flex'} flexDir={'column'} flex={1} overflow={'hidden'} minH={0} h={'100%'} w={'100%'} gap={'1rem'}>
            <Box display={'flex'} flexDir={'row'} gap={'1rem'} flexShrink={0}>
                <Box display={'flex'} flex={1}>
                    <KnjigaSelect onKnjigaChange={knjigaChanged} minimalView={true}/>
                </Box>
                <Box display={'flex'} flex={1}>
                    
                </Box>
            </Box>
            <Box display={'flex'} flexDir={'row'} flex={1} minH={0} overflow={'hidden'} gap={'1rem'}>
                <Box display={'flex'} flexDir={'column'} flex={1} minH={0} overflow={'hidden'}>
                    <Box bg={'grunt.700'} color={'white'} w={'100%'} flexShrink={0}>Odabir goveda</Box>
                    
                    <Box w={'100%'} overflow={'hidden'} minH={0} display={'flex'} flexDir={'column'} flex={1}>
                        <GovedaList _disableboksidgoveda={bokslokacija_id} knjiga_id={state.selectedknjigaid} rowsperpage={15} showButtonSpremi={false} showButtonOdustani={false}
                            naslov={"Odabir goveda"} onSelectGovedo={onGovedoSelect} onRemoveGovedo={onGovedoRemove} preselectedgoveda={getGovedoIdOfSelected()} /*onClose={()=>setShowselectgoveda(false)} preselectedgoveda={getGovedoIdOfSelected()} omigracijaid={odlazakMigracijaId}*//>
                    </Box>
                </Box>
                <Box display={'flex'} flexDir={'column'} flex={1} minH={0} overflow={'hidden'}>
                    <Box bg={'grunt.700'} color={'white'} w={'100%'} flexShrink={0}>Odabrana goveda</Box>
                    <Box w={'100%'} overflow={'hidden'} minH={0} display={'flex'} flexDir={'column'} flex={1}>
                        <GovedaSelected data={state.selectedgoveda} onDelete={onGovedoRemove}/>
                    </Box>
                </Box>
                
            </Box>
            <ButtonGroup gap={'1rem'} mr={'10rem'} flexShrink={0}>
                    <Button rightIcon={<MdSaveAlt/>} colorScheme={'grunt2'} size={size} onClick={()=>onSave(state.selectedgoveda)} >Spremi</Button>
                    <Button colorScheme={'grunt2'} rightIcon={<MdCancel/>} variant={'outline'} size={size} onClick={onClose}>Odustani</Button>
            </ButtonGroup>
        </Box>
  )
}